var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusLevel3 = function SvgBusLevel3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "-2 -2 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7000B",
    d: "M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "rgb(245 153 157)",
    strokeOpacity: 0.5,
    className: "bus-level3_svg__bus-ring"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7000B",
    d: "m6 7-1 .5zM9 7h2zM15 7.5 14 7zM13 5.5H7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1M6 9.5h8zM8 11.5h.005zM12 11.5h.005zM7 13.5v1zM13 14.5v-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m6 7-1 .5M9 7h2m4 .5L14 7m-1 6.5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m6 0H7m6 0v1m-6-1v1m-1-5h8m-6 2h.005m3.995 0h.005"
  })));
};
export default SvgBusLevel3;